import React from 'react';
import styles from './Button.styles'
import { BUTTON_TYPE } from './constants';
import Icons from '../icons/Icons';

export default function Button({ type, title, style, disabled = false, onClickCb, children, className, prefixProps = {} }) {
    return (
        <button title={title} style={{ ...styles.buttonCommon, ...getButtonStyles(type), ...getDisabledStyles(disabled), ...style, ...(prefixProps?.icon && styles.buttonWIcon) }} className={className} disabled={disabled} onClick={onClickCb}>
            {prefixProps?.icon && <Icons familyName='vec' iconName={prefixProps?.icon} />}  {children}
        </button>
    )
}

const getButtonStyles = (type) => {
    switch (type) {
        case BUTTON_TYPE.PRIMARY: default: return styles.buttonPrimary;
        case BUTTON_TYPE.PRIMARY_LIGHT_WITH_BORDER: return styles.buttonPrimaryWithBorder;
        case BUTTON_TYPE.LIGHT_WITH_NO_BORDER: return styles.buttonLightWithNoBorder;

        case BUTTON_TYPE.DANGER: return styles.buttonDanger;
    }
}

const getDisabledStyles = (isDisabled) => {
    if (isDisabled) {
        return styles.disabled;
    } else {
        return {};
    }
}